import "./relationshipView.scss";

import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import { immutableRecords } from "../../types";
import Icon from "../interface/Icon";

class RelationshipColumnHeaderAddColumn extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { columnDisplayItem } = this.props;
    const styles = {
      left: columnDisplayItem.left + `px`
    };
    const entityColumnClasses = `rEntityCol`;
    const itemNameTextClasses = `relationshipHeaderItemNameText relationshipHeaderAddColumn`;

    return (
      <div
        style={styles}
        className={entityColumnClasses}
        onClick={() => {
          this.props.onCreateItemClick(columnDisplayItem.type);
        }}
      >
        <div className="relationshipHeaderItemName">
          <div className={itemNameTextClasses}>
            <div className="rtRotate">
              <Icon icon={columnDisplayItem.icon ? columnDisplayItem.icon : "sidebarAdd"} color="iconMono" />
              {columnDisplayItem.label}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

RelationshipColumnHeaderAddColumn.propTypes = {
  isActiveView: PropTypes.bool.isRequired,
  viewId: PropTypes.string.isRequired,
  columnDisplayItem: PropTypes.instanceOf(immutableRecords.RelationshipColumnDisplayRecord),
  onCreateItemClick: PropTypes.func.isRequired
};

export default RelationshipColumnHeaderAddColumn;
